import React from 'react';
import CustomPage from './CustomPage';

const ContactPage = () => <CustomPage pageSlugOverride="contact" />;

export default ContactPage;

